import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import key_ico from "../../assets/images/key.png";
import login_logo from "../../assets/images/login-logo.png";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";
import { AUTH } from "../../Router/paths";

export default function Verify() {
  const { startLoader, stopLoader } = useLoader();
  const params = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  const handleInputChange = (e, func) => {
    func(e.target.value);
  };

  const verifyNewPassword = (e) => {
    e.preventDefault();
    if (password === "" && password2 === "")
      return toast.warn("password is required");
    if (password !== password2)
      return toast.warn("password and confirm password not match");
    startLoader();
    const data = {
      password,
      password2,
    };
    axiosInstance
      .post(`/api/user/reset-password/${params.id}/${params.token}/`, data)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          toast.success(Data.msg);
          navigate(AUTH.login);
        } else {
          toast.warning(Data.msg);
          navigate(AUTH.forgotPassword);
        }
      })
      .catch(() => {
        stopLoader();
        navigate(AUTH.forgotPassword);
      });
  };
  return (
    <>
      <div
        className="login-sec pc-p-4"
        style={{
          background:
            "url('../assets/login-bg.png') no-repeat center center / cover",
        }}
      >
        <div className="container-fluid px-5">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="login-form">
                <Link to={AUTH.login}>
                  <div className="login-logo">
                    <img src={login_logo} alt="Logo" />
                  </div>
                </Link>
                <div className="login-content">
                  <h4>Create New Password</h4>
                  {/* <h5 className="text-center">Set New Password</h5> */}
                  <span>OR</span>
                </div>
                <form
                  action=""
                  className="main-form"
                  onSubmit={verifyNewPassword}
                >
                  <label htmlFor="">New Password</label>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => handleInputChange(e, setPassword)}
                      placeholder="Enter New Password"
                    />
                    <img src={key_ico} alt="key" />
                  </div>
                  <label htmlFor="">Confirm New Password</label>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control"
                      value={password2}
                      onChange={(e) => handleInputChange(e, setPassword2)}
                      placeholder="Confirm New Password"
                    />
                    <img src={key_ico} alt="key" />
                  </div>
                  <div className="text-center">
                    <button className="primary-btn secondary-bg px-5">
                      Change Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
